import React from 'react'
import OrderForm from '~/components/OrderForm'
import PublicLayout from '~/components/PublicLayout'

export default () => {
  return (
    <PublicLayout>
      <OrderForm />
    </PublicLayout>
  )
}
